import { BLOCK_TYPE, NUMBER_TYPE, TILE_COLORS } from './constants';

export const randomTileValue = () => (Math.random() < 0.9 ? 2 : 4);

export const coordsKey = (r, c) => `${r}-${c}`;

export const makeNumberTile = (value, row, col, nextId) => ({
  id: nextId(),
  value,
  row,
  col,
  type: NUMBER_TYPE,
  isNew: true,
});

export const makeBlockTile = (row, col, nextId) => ({
  id: nextId(),
  value: 'X',
  row,
  col,
  type: BLOCK_TYPE,
  expiresAt: Date.now() + 20000,
  isNew: true,
});

export const tileClassName = (tile) => {
  const base =
    'absolute flex items-center justify-center rounded-[22px] border-[6px] border-black text-3xl md:text-4xl lg:text-5xl font-semibold select-none transition-transform duration-[260ms] ease-[cubic-bezier(0.22,0.75,0.35,1.05)] will-change-transform';

  const motion =
    tile.justMerged ? 'tile-merge' : tile.isNew ? 'tile-appear' : '';

  const visualValue = tile.colorValue ?? tile.value;

  if (!tile.value) {
    return `${base} bg-[#8f8f8f] text-transparent ${motion}`;
  }

  if (tile.type === BLOCK_TYPE) {
    return `${base} bg-[#111827] text-white ${motion}`;
  }

  const color = TILE_COLORS[visualValue] || 'bg-[#3c3a32]';
  const textColor = visualValue <= 4 ? 'text-[#2d241e]' : 'text-white';
  return `${base} ${color} ${textColor} ${motion}`;
};
